import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { Icon, blockDefault } from '@wordpress/icons';
import { DEFAULT_ICON_WIDTH } from '@constants';

const {
  i18n: { __ },
  element: { useState },
  components: { Button, Modal, SearchControl },
} = wp;

const IconLibraryInserterModal = (props) => {
  const { setIconLibraryInserterOpen, attributes, setAttributes, allIcons } =
    props;
  const [searchInput, setSearchInput] = useState('');

  let shownIcons = [];
  if (searchInput) {
    shownIcons = allIcons.filter((icon) =>
      icon.title.toLowerCase().includes(searchInput.toLowerCase()),
    );
  } else {
    shownIcons = allIcons;
  }

  const updateIconAttributes = (iconDetail) => {
    setAttributes({
      icon: '',
      iconName: iconDetail.name,
      iconExtension: '',
      width: DEFAULT_ICON_WIDTH,
      enableWidth: true,
    });
    setIconLibraryInserterOpen(false);
  };

  const iconListTemplate = (
    <div className="icons-list">
      {shownIcons.map((icon) => (
        <Button
          key={`icon-${icon.name}`}
          className={classnames('icons-list__item', {
            'is-active': icon.name === attributes?.iconName,
          })}
          onClick={() => {
            updateIconAttributes(icon);
          }}
        >
          <span className="icons-list__item-icon">
            <Icon icon={icon.icon} size={24} />
          </span>
          <span className="icons-list__item-title">
            {icon?.title ?? icon.name}
          </span>
        </Button>
      ))}
    </div>
  );

  const noResults = (
    <div className="icon-block__no-results">
      <Icon icon={blockDefault} />
      <p>{__('No results found.', 'b3rg')}</p>
    </div>
  );
  return (
    <Modal
      className="icon-inserter__modal"
      title={__('Icon Library', 'b3rg')}
      onRequestClose={() => setIconLibraryInserterOpen(false)}
      isFullScreen
    >
      <div className="icon-inserter">
        <SearchControl value={searchInput} onChange={setSearchInput} />
        <div className="icon-inserter__content">
          <div className="icon-inserter__content-grid">
            {[
              isEmpty(shownIcons) && noResults,
              !isEmpty(shownIcons) && iconListTemplate,
            ]}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default IconLibraryInserterModal;
